import { render, staticRenderFns } from "./AddressEstatePlanning.vue?vue&type=template&id=7d126183"
import script from "./AddressEstatePlanning.vue?vue&type=script&lang=js"
export * from "./AddressEstatePlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports